//TECH FEATURES FILTER
$(document).ready(function() {
  $('.footer__item--social-media .footer__item-content').prepend('<img src="https://d1yvdgbmeqok5q.cloudfront.net/hawx/img/go_further_300x100.png">');
  
  var techArray = ["Composite Safety Toe","Electrical Hazard","Flame Resistant","High-Visibility","Insulated","Made in USA","Puncture Resistant","Slip Resistant","Steel Toe","Waterproof","Aislado","Aislada","Impermeable"];

  // MutationObserver is used to detect changes in the DOM
  const observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
          if (mutation.type === 'childList') {
              // Check for added nodes with the specified class
              $(mutation.addedNodes).find('collapsible-content[id="facet-filter-filter.p.tag"] .checkbox-container').each(function() {
                  $('collapsible-content[id="facet-filter-filter.p.tag"] .checkbox-container').each(function() {
                      var value = $(this).find('.checkbox').val();
                      if ($.inArray(value, techArray) !== -1) {
                          $(this).closest('.checkbox-container').addClass('show');
                      } else {
                          $(this).closest('.checkbox-container').addClass('hidden');
                      }
                  });
              });

              // Check for added nodes that are the element with the specified class
               $(mutation.addedNodes).filter('collapsible-content[id="facet-filter-filter.p.tag"] .checkbox-container').each(function() {
                 $('collapsible-content[id="facet-filter-filter.p.tag"] .checkbox-container').each(function() {
                      var value = $(this).find('.checkbox').val();
                      if ($.inArray(value, techArray) !== -1) {
                          $(this).closest('.checkbox-container').addClass('show');
                      } else {
                          $(this).closest('.checkbox-container').addClass('hidden');
                      }
                  });
              });
          }
      });
    if ($('collapsible-content[id="facet-filter-filter.p.tag"] .checkbox-container.show').length == 0) {
      $('collapsible-content[id="facet-filter-filter.p.tag"]').closest('.product-facet__filter-item').hide();
    }
  });

  // Configure the observer to watch for changes to the element's children
  const config = { childList: true, subtree: true };

  // Start observing the document body for changes
  observer.observe(document.body, config);

  // Initial check for existing elements on page load
   $('collapsible-content[id="facet-filter-filter.p.tag"] .checkbox-container').each(function() {
     $('collapsible-content[id="facet-filter-filter.p.tag"] .checkbox-container').each(function() {
          var value = $(this).find('.checkbox').val();
          if ($.inArray(value, techArray) !== -1) {
              $(this).closest('.checkbox-container').addClass('show');
          } else {
              $(this).closest('.checkbox-container').addClass('hidden');
          }
      });
  });
  if ($('collapsible-content[id="facet-filter-filter.p.tag"] .checkbox-container.show').length == 0) {
      $('collapsible-content[id="facet-filter-filter.p.tag"]').closest('.product-facet__filter-item').hide();
  }
});

//remove extra space when no tech icons
if ($('.tech-icons').text().trim() === '') {
  $('.tech-icons').closest('.section').hide();
}

//CORDIAL
// footer - email_signup
$(document).on('click','.newsletter__form button.button', function(){
    var email = $('input.is-filled[type="email"]').val().trim();
    var formValidation = true;

    var regexEmail = /^([a-zA-Z0-9_\.\-\+])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;
    if (String(email).match(regexEmail) == null ) {
      formValidation = false;
    }

    if (formValidation){
      var auth_data = {
        email: email
      }			

      var contact_data = {
        'channels': {
          'email': {
            'subscribeStatus': 'subscribed'
          }
        },		          
        'source_create': 'footer',       
        'signup_source': 'footer',
        'welcome_signup': true
      };

      var properties = {
        'source_create': 'footer',   
        'signup_source': 'footer',
        'welcome_signup': true,
      };

      crdl([				
        ['contact', auth_data, contact_data,{'upsert': true}],
        ['event', 'email_signup', properties]
      ]);
    }
});

//register page - account_create
$('#register-customer button.button').bind({
  click: function(){
    var firstName = $('input[name="customer[first_name]"]').val().trim();
    var lastName = $('input[name="customer[last_name]"]').val().trim();
    var email = $('input[name="customer[email]"]').val().trim();
    var password = $('input[name="customer[password]"]').val().trim();
    var formValidation = true;
    
    var regexPassword = /^.{6,}$/;
    if ( String(password).match(regexPassword) == null ) {
      formValidation = false;
    }

    if (!email || !firstName || !lastName || !password) {
      formValidation = false;
    }
    
    var loginProperties = {
      'email': email
    };
    
    if (formValidation && $('.errors').length == 0){
      var auth_data = {
        email: email
      }

      var contact_data = {
        'channels': {
            'email': {
              'subscribeStatus': 'none'
            }
        },        
        'first_name': firstName,
        'last_name': lastName,
        'source_create': 'myaccount'
      };      


      crdl([       
        ['contact', auth_data, contact_data,{'upsert': true}],
        ['event', 'account_create'],
        ['event', 'login', loginProperties]
      ]);
    }
  }
});

//login page - login
$('#customer_login button.button').bind({
  click: function(){
    var username = $('.account__block-item input[id="customer[email]"]').val().trim();
        
    var auth_data = {
        email: username
    }
        
    var contact_data = {
        'channels': {
            'email': {
                'address': username      
            }
        }
    };
    
    var properties = {
        "email": username
    };
        
    crdl([        
        ['contact', auth_data, contact_data],
        ['event', 'login', properties]
    ]);
  }
});

//remove leading <br> tag in pdp description
//collapse description toggle when mobile
$(document).ready(function() {
  $('.product-tabs__tab-item-content br').remove();
  if ($(window).width() > 790) { 
    $('.shopify-section--product-content button.collapsible-toggle').trigger('click');
  }
  //remove section block to fix spacing, if no pdp reviews/special image/video  
//setTimeout(function(){
  if($('.jdgm-rev-widg').attr('data-number-of-reviews') == 0) {
    $("div[id*='__1745532168a22de499']").hide();
  }
  if ($('#special-product-image').length < 1 ) {
    $("div[id*='_etphmT']").hide();
  }
  if ($('#special-product-video').length < 1 ) {
    $("div[id*='_xetXM6']").hide();
  }
//}, 3000);
});